<template>
	<div class="m-doc-base">
		<div v-if="$scopedSlots.title" class="title"><slot name="title"></slot></div>

		<div class="info flex-wrap">
			<slot name="info"></slot>
		</div>

		<p v-if="status == 2" class="state" style="color: #00ACA9;">审批通过</p>
		<p v-else-if="status == 3" class="state" style="color: #FF5555;">审批驳回</p>
		<p v-else-if="status == 1 && approver" class="state" style="color: #FF6900;">等待【{{approver}}】处理</p>

		<i v-if="status == 2" class="state-icon tf" style="color: #48CE81;">&#xe771;</i>
		<i v-else-if="status == 3" class="state-icon tf" style="color: #FF5555;">&#xe770;</i>
	</div>
</template>

<script>
	export default {
		name: 'docBase',

		data() {
			return {
				status: '',
				approver: ''
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-doc-base {
		position: relative;
		padding: 20px 24px;
		background: linear-gradient(0deg, #FFFFFF, #EEFAFF);

		.title {
			line-height: 26px;
			font-size: 18px;
			font-weight: bold;
			word-break: break-word;
		}

		.info {
			max-width: 500px;
			margin-top: 8px;

			>>> .c-field {
				width: 50%;

				&-label {
					color: #666;
				}

				&-content {
					color: #666;
				}
			}
		}

		.state {
			margin-top: 8px;
			font-size: 14px;

			&-icon {
				position: absolute;
				right: 14px;
				top: 10px;
				font-size: 70px;
			}
		}
	}
</style>
